import React, { Suspense, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import "react-quill/dist/quill.snow.css";
import "./scss/main.scss";
import configureStoreProd from "./Pages/config/configureStore.prod";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import { lazy } from "react";
import {useDispatch,useSelector } from "react-redux";
import { logout } from "./Pages/actions/user";
import { useNavigate } from "react-router-dom";

const { persistor, store } = configureStoreProd();

const PageRoute = ({children,auth}: any) => {
  const user = useSelector((state:any) => state.user);
  const dispatch=useDispatch()
    const history = useNavigate();
  const Logout = () => {
    dispatch(logout());
    sessionStorage.removeItem("persist:admin-app");
    sessionStorage.removeItem("token");
    // localStorage.removeItem("loginTime")
    history("/login");
  };
 useEffect(() => {
    if(!user?.loggedIn && auth)
    {
      Logout()
    }
  }, []);

  const noAccess=(auth && !user?.loggedIn)
  if(noAccess) return <></>
  return <>
    {children}</>
}

function App() {

  const routes = [
    { url: "/login", path: "Login",noAuth:true },
    { url: "/dashboard", path: "Dashboard" },
    { url: "*", path: "NotFoundPage",noAuth:true  },
    { url: "/profile", path: "Profile" },
    { url: "/profile/:tab", path: "Settings" },
    { url: "/forgotpassword", path: "Forgotpassword",noAuth:true  },
    { url: "/resetpassword", path: "Resetpassword",noAuth:true  },
    { url: "/staff", path: "Users" },
    { url: "/staff/edit/:id", path: "Users/AddEdit" },
    { url: "/staff/add", path: "Users/AddEdit" },
    { url: "/staff/detail/:id", path: "Users/View" },
    { url: "/", element: <Navigate to="/login" />,noAuth:true  },

    { url: "/customers", path: "Customer" },
    { url: "/customers/edit/:contactId", path: "Customer/AddEdit" },
    { url: "/customers/add/:id", path: "Customer/AddEdit" },
    { url: "/customers/detail/:id", path: "Customer/View" },


    { url: "/contacts", path: "Contact" },
     { url: "/contacts/detail/:id", path: "Contact/View" },

     { url: "/enviroment", path: "Enviroment/Edit" },
     { url: "/datarefresh", path: "BusniessCentral/Import" },

    { url: "/dimensioncategory", path: "DimensionCategory" },
    { url: "/dimensioncategory/edit/:id", path: "DimensionCategory/AddEdit" },
    { url: "/dimensioncategory/add", path: "DimensionCategory/AddEdit" },
    { url: "/dimensioncategory/detail/:id", path: "DimensionCategory/View" },


    { url: "/dimensionmanagement", path: "DimensionManagement" },
    { url: "/dimensionmanagement/edit/:id", path: "DimensionManagement/AddEdit" },
    { url: "/dimensionmanagement/add", path: "DimensionManagement/AddEdit" },
    { url: "/dimensionmanagement/detail/:id", path: "DimensionManagement/View" },


    { url: "/partmanagement", path: "PartManagement" },
    { url: "/partmanagement/edit/:id", path: "PartManagement/AddEdit" },
    { url: "/partmanagement/add", path: "PartManagement/AddEdit" },
    { url: "/partmanagement/detail/:id", path: "PartManagement/View" },

    { url: "/taxcode", path: "TaxManagement" },
    { url: "/taxcode/edit/:id", path: "TaxManagement/AddEdit" },
    { url: "/taxcode/add", path: "TaxManagement/AddEdit" },
    { url: "/taxcode/detail/:id", path: "TaxManagement/View" },

    { url: "/concerntype", path: "ConcernType" },
    { url: "/concerntype/edit/:id", path: "ConcernType/AddEdit" },
    { url: "/concerntype/add", path: "ConcernType/AddEdit" },
    // { url: "/concerntype/detail/:id", path: "ConcernType/View" },


    { url: "/helpdesk", path: "HelpDesk" },
    { url: "/notification", path: "Notification" },
    { url: "/helpdesk/reply/:id", path: "HelpDesk/Reply" },
    { url: "/helpdesk/detail/:id", path: "HelpDesk/View" },

    { url: "/quote", path: "Quote" },
    { url: "/quote/add", path: "Quote/AddEdit" },
    { url: "/Quote/detail/:id", path: "Quote/View" },
    { url: "/Quote/summary/:id", path: "Quote/QuoteSummary" },
    { url: "/Quote/add/:quoteId?", path: "Quote/AddEdit" },
    { url: "/quote/edit/:id", path: "Quote/AddEdit" },


    { url: "/order", path: "Order" },
    { url: "/order/detail/:id", path: "Order/View" },

    { url: "/order-line-status", path: "OrderLineStatus" },
    { url: "/order-line-status/detail/:id", path: "OrderLineStatus/View" },

    { url: "/website-tracker", path: "WebsiteTracker" },
    { url: "/website-tracker/detail/:id", path: "WebsiteTracker/View" },
    { url: "/website-tracker/add", path: "WebsiteTracker/AddEdit" },
    { url: "/website-tracker/edit/:id", path: "WebsiteTracker/AddEdit" },

    { url: "/customer-survey", path: "CustomerSurvey" },
    { url: "/notification-emails", path: "NotificationEmails" },
    // The page was Pricing Alerts until it took every notification email.
    { url: "/pricing-alerts", element: <Navigate to="/notification-emails" replace /> },

    { url: "/invoice", path: "Invoice" },
    { url: "/invoice/detail/:id", path: "Invoice/View" },

  ];
  sessionStorage.removeItem('activeRooms');

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={"loading ..."} persistor={persistor}>
          <Suspense
            fallback={
              <div id="loader" className="loaderDiv">
                <div>
                  <img
                    src="/assets/img/loader.gif"
                    alt="logo"
                    className="loaderlogo"
                  />
                </div>
              </div>
            }
          >
            <Router>
              <Routes>
                {routes.map((itm) => {
                  const Element = lazy(() => import(`./Pages/${itm.path}`));
                  return (
                    <Route
                      path={itm.url}
                      element={itm.path ? <PageRoute auth={itm?.noAuth?false:true}><Element /></PageRoute> : itm.element}
                    />
                  );
                })}
              </Routes>
            </Router>
          </Suspense>
        </PersistGate>
      </Provider>
      <div id="loader" className="loaderDiv d-none">
        <div>
          <img src="/assets/img/loader.gif" alt="logo" className="loaderlogo" />
        </div>
      </div>
      <ToastContainer position="top-right" />
    </>
  );
}

export default App;
